import { filter } from 'rxjs/operators';
import { SecuritiesProperty } from 'src/app/models/securities-property/securities-property';
import { title } from 'process';
import { SelectItem } from 'primeng/api';
import { Component, OnInit } from '@angular/core';
import { Customer } from 'src/app/models';
import { CustomerExporterService } from 'src/app/services/customer-exporter.service';
import { CustomerService } from 'src/app/services/customer.service';
import { ToastService } from 'src/app/services/toast.service';
import { SecuritiesPropertyFilter } from 'src/app/models/dtos/securities-property/securities-property-filter';
import { SecuritiesPropetyFilterToReport } from 'src/app/models/dtos/securities-property/securities-propety-filter-to-report';
import { MessageUtil } from 'src/app/utils/message.util';
import { SecuritiesPropertyService } from 'src/app/services/securities-property/securities-property.service';
import { SecuritiesPropertyFilterToReportReturn } from 'src/app/models/dtos/securities-property/SecuritiesPropertyFilterToReportReturn';

interface ReportItem {
  title: string;
  description: string;
  route: string;
}

@Component({
  selector: 'app-customer-reports',
  templateUrl: './customer-reports.component.html',
  styleUrls: ['./customer-reports.component.scss']
})
export class CustomerReportsComponent implements OnInit {

  availableReports: ReportItem[] = [];
  exportList: SecuritiesPropertyFilterToReportReturn[] = [];

  tilesInUse : SelectItem [] = [
    { label: 'Todos', value: null },
    { label: 'Com Proprietário Vinculado', value: 1 },
    { label: 'Vagos', value: 2 }]

  titlesActive: SelectItem [] = [
    { label: 'Todos', value: null },
    { label: 'Ativos', value: 1 },
    { label: 'Inativos', value: 2 }]

  titlesTypes: SelectItem [];


  titlesOrder: SelectItem [] = [
    { label: 'Nome', value: true },
    { label: 'Número', value: false }]


  filter :SecuritiesPropetyFilterToReport = new SecuritiesPropetyFilterToReport();


  constructor(
    private customerService: CustomerService,
    private customerExporterService: CustomerExporterService,
    private toastService: ToastService,
    private messageUtil: MessageUtil,
    private securitiesPropertyService:SecuritiesPropertyService,
  ) {}

  ngOnInit() {
    this.getTitleProperties();
  }

  find(){
    this.securitiesPropertyService.getAssociateslist(this.filter).subscribe({
      next: (value) => {

        this.exportList = value;
        this.customerExporterService.exportTitlersAndDependents(this.exportList,this.filter.showDependents);
      }, error: err => {
        this.toastService.error(err.error.data.exception.message);
      }
    });



  }

 getTitleProperties():void {
    this.customerService.getTitlePropertiesByMarinaId().subscribe({
      next: (data) => {
        this.titlesTypes =
          data.map((c) => ({ label: c.name, value: c.id }));


            this.filter.titlePropertyType.push(...this.titlesTypes.map((c) => c.value));

      },


      error: (error) => {
        const exception = error.error.data.exception;
        this.messageUtil.generateMessage(
          exception.type,
          exception.title,
          exception.message
        );
      },
    });
  }

}
